module.exports = __webpack_public_path__ + "static/demonightlifemuseumcom-252955321c6e140d2109a2164f7512ed.jpg";